import { useMutation } from '@tanstack/react-query';
import { useLocationsStore } from '../useLocationsStore';
import { FIVE_SECONDS, showToast, TOAST_ERROR } from 'lib/utils';
import { makeGetReportAttachments } from 'main/factories/usecases';
import { ReportRow, ReportTransactionDataRow } from '@hone-automation/common';

export const useGetReportAttachments = (locationId?: string) => {
  const currentLocation = useLocationsStore.getState().currentLocation;
  const effectiveLocationId = locationId || currentLocation?.id;

  return useMutation({
    mutationFn: (reportTransactionsRows: ReportTransactionDataRow[]) => {
      if (!effectiveLocationId) {
        throw new Error('Location ID is required to fetch report attachments');
      }
      const reportAttachmentsService = makeGetReportAttachments();
      return reportAttachmentsService.getReportAttachments({
        locationId: effectiveLocationId,
        dataRows: reportTransactionsRows,
      }) as Promise<ReportRow[]>;
    },
    onError: (error: any) => {
      showToast(error.message, TOAST_ERROR, FIVE_SECONDS);
    },
  });
};
